import AssessmentPromptField, {
  ASSESSMENT_PROMPT_MAX_LENGTH,
} from "./AssessmentPromptField";
import { useDefaultAssessmentPrompt } from "../../../hooks/useDefaultAssessmentPrompt";

type AssessmentPromptFieldWithDefaultProps = Readonly<{
  conceptCode: string;
  objectType?: string;
  objectSubType?: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  maxLength?: number;
}>;

export default function AssessmentPromptFieldWithDefault({
  conceptCode,
  objectType,
  objectSubType,
  value,
  onChange,
  error = false,
  helperText,
  maxLength = ASSESSMENT_PROMPT_MAX_LENGTH,
}: AssessmentPromptFieldWithDefaultProps) {
  const { defaultPrompt, loading, error: loadError } =
    useDefaultAssessmentPrompt(conceptCode, {
      targetType: objectType,
      subType: objectSubType,
    });

  const resolvedHelperText =
    helperText ||
    (loadError ? loadError : loading ? "Loading default prompt..." : undefined);

  return (
    <AssessmentPromptField
      value={value}
      suggestedPrompt={defaultPrompt}
      onChange={onChange}
      error={error || Boolean(loadError)}
      helperText={resolvedHelperText}
      maxLength={maxLength}
      showDefaultPromptInfo
    />
  );
}
